export const messages = {
  zh: {
    app: {
      rainseeTitle: '雨见AI',
      xinyiTitle: '芯毅AI',
      aihelpTitle: 'aihelp'
    },
    language: {
      label: '语言',
      options: {
        zh: '中文',
        en: 'English'
      }
    },
    chatLayout: {
      newChat: '新建会话',
      backupReminderButton: '提醒备份',
      emptyState: '今天想聊点什么？',
      copyCode: '复制',
      copied: '已复制',
      deleteSessionConfirm: '确定要删除这个会话吗？',
      scrapeStatusSingle: '正在获取网页内容 {url} ({seconds}s)...',
      scrapeStatusMulti: '正在获取网页内容 ({finished}/{total}) ({seconds}s)...',
      backupNever: '您尚未备份过数据，点击此处导出备份。',
      backupOverdue: '您已经 {days} 天没备份了，点击立即备份。',
      exportFailed: '导出失败: {message}'
    },
    markdownRenderer: {
      copyCode: '复制',
      editCode: '编辑',
      copied: '已复制',
      copyFailed: '复制失败'
    },
    codeEditor: {
      title: '编辑代码',
      defaultName: '代码片段',
      aiDescription: '描述你想调整的地方，AI 会基于当前代码逐步修改。',
      promptPlaceholder: '例如：把循环改成 map，并补充错误处理',
      safetyNote: '修改只会更新对话中的这段代码，不会自动运行。',
      footerHint: '保存后会直接替换对话中的这段代码。',
      save: '保存到对话',
      publishing: '保存中...',
      applied: '代码已更新',
      applyFailed: '无法定位原代码块，修改未写入。',
      sourceChanged: '这条消息已变化，无法写回原代码块。'
    },
    browserAgent: {
      unnamedSession: '未命名会话',
      conversationUser: '用户',
      conversationAssistant: '助手',
      kbRequiresLogin: '必须登录才可以使用知识库功能',
      noConversationForKb: '当前还没有可整理到知识库的对话内容',
      pageUrlUnavailable: '无法获取当前网页链接',
      selectionTextUnavailable: '无法获取当前选中的文本',
      kbAdded: '已成功添加到知识库',
      kbAddFailed: '添加失败: {message}',
      requestRetry: '请求出错，请稍后重试',
      unknownPage: '未知网页',
      kbLookupStatus: '正在访问知识库 ({seconds}s)...',
      kbLookupStopped: '已停止访问知识库，正在直接回答...',
      pdfExportNotReady: '暂未实现完整的 PDF 导出，可通过浏览器自带打印功能保存。',
      copied: '已复制',
      loadingFailed: '抱歉，当前网页内容读取失败了。不过没关系，你可以把我当成普通的 AI 助手，随便问我任何问题。',
      contextStopped: '网页读取已终止。我现在是一名普通的 AI 助手，你可以问我任何问题。',
      searchSeenPrefix: '我已经看到你在搜索',
      searchSeenSuffix: '，我可以直接帮你解答。',
      askAnything: '或者你也可以问我其他问题',
      pageSeenPrefix: '我已经看到你在看的',
      pageSeenFallback: '网页',
      pageSeenMiddle: '了，并且为你装载好了',
      pageSeenSuffix: '技能。',
      preparedQuestions: '我准备了几个你可能会问的问题，当然你也可以随便问我其他任何问题',
      decision: {
        pageAction: '正在执行网页操作：**{command}**...',
        generateCharacter: '正在为您创建伙伴：**{name}**...',
        addToKnowledgeBase: '正在将网页加入知识库...'
      },
      quickActions: {
        tempEmail: '临时邮箱',
        tempEmailResponse: '为了防止垃圾邮件骚扰并保护您的个人隐私，我已经为您生成了一个专属的临时邮箱（仅10分钟内有效）。\n\n⚠️ **提示**：请勿将其用于任何违法违规操作。',
        addToKnowledgeBase: '加入知识库',
        askSelection: '请基于我选中的这段内容回答我的问题，先解释重点，再给出必要的补充。',
        addToKnowledgeBaseResponse: '好的，正在将当前网页加入您的个人知识库...'
      },
      system: {
        defaultRolePrompt: '你是一个浏览器 AI 助手。',
        searchSummary: '用户搜索的内容是：{summary}',
        pageContext: '当前网页标题: {title}\n网页URL: {url}\n网页摘要:\n{summary}',
        searchEngineHeader: '\n\n[来自搜索引擎的信息]:\n',
        referencesHeader: '参考资料:\n',
        kbHeader: '\n\n[来自知识库的参考信息]:\n',
        kbSegment: '--- 知识段落 {index} ---\n{content}\n',
        kbInstruction: '\n请结合上述知识库的参考信息回答用户的问题。如果参考信息中没有包含相关内容，请根据你自己的知识作答。\n'
      }
    },
    browserAgentChat: {
      thinkingSearch: '联网搜索过程与结果',
      thinking: '思考过程',
      viewFile: '点击查看 {name}',
      answerDirectly: '直接回答',
      kbJudgingStatus: '正在智能筛选 {count} 个知识库片段...',
      kbUseDirectly: '直接引用',
      kbSkip: '不用资料',
      drawing: 'AI 正在绘图...',
      copyTraceId: '复制对话ID {id}',
      aiGenerated: '本内容由AI生成',
      quotaLimitTitle: '今日免费次数已用完',
      quotaLimitDesc: '内置免费模型每天可用 {limit} 次，今天的额度已全部用完，24 小时内自动恢复。',
      quotaLimitUsage: '今日已用 {limit} / {limit}',
      quotaLimitUpsell: '不想等？购买 Token 按量付费，1 元起，买完自动切换，不限次数。',
      quotaLimitBuy: '购买 Token 继续使用',
      quotaLimitByok: '也可在设置中添加自己的 API Key',
      quotaSwitchedTitle: '已切换到 {name}',
      quotaSwitchedDesc: '后续回答将使用你的模型，不再受每日免费次数限制。',
      quotaAskAgain: '重新提问',
      commandRequest: 'AI 请求执行命令',
      reject: '拒绝',
      allowExecution: '允许执行',
      kbSources: '知识库来源',
      quotedSegments: '引用分段 {count}',
      unknownSource: '未知来源',
      searchSuggestion: '在{engine}中搜索：{keyword}',
      copy: '复制',
      edit: '编辑',
      stopSpeaking: '停止朗读',
      speak: '朗读',
      knowledgeBase: '知识库',
      export: '导出',
      exportPdf: '导出 PDF',
      exportWord: '导出 Word',
      exportMarkdown: '导出 Markdown',
      aiAssistant: 'AI 助手',
      selectedTextPrefix: '我看到你选中了',
      selectedTextSuffix: '，是需要：',
      fillInput: '填充到输入框',
      traceCopiedAlert: '会话id已复制，测试阶段，如果有问题，您可以将id发送给作者，协助作者排查，感谢',
      report: '举报',
      reportDialogTitle: '举报这条回答',
      reportDialogTraceId: '会话 ID: {id}',
      reportTypeLabel: '问题类型',
      reportReasonLabel: '举报理由',
      reportReasonPlaceholder: '请详细说明具体问题，方便核实处理。',
      reportCancel: '取消',
      reportSubmit: '提交举报',
      reportSubmitting: '提交中...',
      reportReasonRequired: '请填写举报理由',
      reportSuccessAlert: '举报已提交，感谢反馈。',
      reportFailed: '举报提交失败，请稍后重试。',
      reportTypeFactuallyIncorrect: '与事实不符',
      reportTypeIllegal: '违法违规',
      reportTypeFraud: '诈骗或误导',
      reportTypePorn: '色情低俗',
      reportTypeViolence: '暴力仇恨',
      reportTypePrivacy: '隐私侵权',
      reportTypeOther: '其他问题',
      userscriptReady: '脚本已生成',
      userscriptVersion: '版本 {version}',
      installUserscript: '安装脚本',
      editUserscript: '编辑代码',
      engines: {
        baidu: '百度',
        mita: '秘塔'
      }
    },
    userscriptEditor: {
      title: '编辑网页脚本',
      defaultName: '当前 userscript',
      close: '关闭编辑器',
      sourceTitle: '源码编辑',
      unsaved: '有未保存修改',
      saved: '未修改',
      aiTitle: '让 AI 修改',
      aiDescription: '描述你想调整的功能，AI 会基于当前源码修改。',
      promptLabel: '修改要求',
      promptPlaceholder: '例如：增加一个右下角开关，点击后暂停脚本运行',
      modify: '开始修改',
      stop: '停止',
      modifying: 'AI 正在修改源码...',
      modifySuccess: '修改已写入编辑器，请检查后保存。',
      modifyStopped: '已停止修改，当前源码仍保留。',
      modifyFailed: 'AI 修改失败，请重试。',
      requestStep: '修改要求',
      waitingStep: '等待 AI 指令',
      waitingStepMessage: '正在根据前 {count} 个工具结果决定下一步…',
      viewStep: '查看命令与结果',
      toolStep: '执行工具',
      searchStep: '搜索源码',
      readStep: '读取源码',
      replaceStep: '修改源码',
      replaceFailed: '替换未执行',
      finishStep: '完成修改',
      editComplete: '修改完成',
      editStopped: '修改已停止',
      noChanges: 'AI 没有对源码执行任何修改',
      tooManySteps: 'AI 修改超过 16 个工具步骤，已停止。',
      emptySource: '源码不能为空。',
      sourceTooLarge: '源码不能超过 512KB。',
      syntaxError: '源码语法错误',
      safetyNote: '脚本会在当前网页中运行，请只保留你信任的代码。',
      footerHint: '保存后会生成新的脚本链接，原对话不会新增消息。',
      cancel: '取消',
      save: '保存并返回',
      publishing: '发布中...',
      publishFailed: '脚本发布失败，请重试。',
      discardConfirm: '当前有未保存的修改，确定放弃并返回对话吗？'
    },
    chatInput: {
      instructions: ['帮我解答', '这是什么'],
      uploadInvalidUrl: '上传失败或返回了无效链接。',
      documentProcessingFailed: '文档处理失败。',
      fileUploadFailed: '文件上传失败。',
      voiceUnsupported: '当前浏览器不支持语音输入功能',
      microphoneDenied: '语音输入失败：麦克风权限被拒绝，请在浏览器设置中允许使用麦克风。',
      voiceError: '语音输入发生错误：{message}',
      unknownError: '未知错误'
    },
    characterManager: {
      title: '伙伴中心',
      myRoles: '我的伙伴',
      onlineStore: '在线商店',
      createRole: '+ 创建您的伙伴',
      import: '📥 导入',
      myDownloads: '我的下载 / 自定义',
      uncategorized: '未分类',
      shareToStore: '分享到商店',
      exportJson: '导出 JSON',
      edit: '编辑',
      delete: '删除',
      systemDefault: '系统默认',
      hide: '隐藏',
      hideBlockedRoles: '隐藏已屏蔽的伙伴',
      showHiddenRoles: '显示 {count} 个已屏蔽的伙伴',
      restoreVisibility: '恢复显示',
      loadingStore: '正在加载在线商店...',
      downloadRole: '获取伙伴',
      emptyStore: '暂无在线伙伴',
      editRole: '编辑伙伴',
      createNewRole: '创建您的伙伴',
      avatarLabel: '头像 (Emoji)',
      nameLabel: '名称',
      namePlaceholder: '伙伴名称',
      shortDescriptionLabel: '简短描述',
      descriptionPlaceholder: '一句话描述这个伙伴的职责',
      aliasesLabel: '伙伴别名',
      aliasesPlaceholder: '例如：翻译、英文翻译（用逗号分隔）',
      systemPromptLabel: 'System Prompt (核心设定)',
      systemPromptPlaceholder: '详细设定伙伴的能力、工作方式、语气等...',
      tagsLabel: '标签 (Tags)',
      tagsPlaceholder: '例如: 助手, 编程, 幽默 (用逗号分隔)',
      cancel: '取消',
      save: '保存',
      deleteConfirm: '确定要删除这个伙伴吗？',
      importSuccess: '导入成功！',
      importFailed: '导入失败：无效的文件格式',
      shareConfirm: '确定要将此伙伴分享到在线商店吗？任何人都可以看到并下载。',
      shareSuccess: '分享成功！',
      shareFailed: '分享失败：{message}',
      unknownError: '未知错误',
      duplicateDownloaded: '已覆盖同名伙伴 "{name}" 并下载到"我的伙伴"',
      downloaded: '已下载并添加到"我的伙伴"'
    },
    settingsModal: {
      title: '设置',
      tabs: {
        general: '常规',
        model: '模型',
        appearance: '外观',
        memory: '记忆',
        backup: '备份',
        about: '关于'
      },
      generalTitle: '常规设置',
      theme: '主题',
      themeLight: '浅色',
      themeDark: '深色',
      appearanceTitle: '外观设置',
      fontSizeLabel: '对话框文字大小',
      fontPreview: '这是调整后的文字显示效果',
      memory: {
        title: '记忆管理', subtitle: '查看并管理 AI 用来理解你和保持个性的记忆。', localBadge: '保存在本地',
        privacyTitle: '你的记忆存储在本地',
        privacyDesc: '记忆保存在当前浏览器的本地数据库中，不会作为云端同步数据保存。AI 自动整理记忆时，相关对话和已有记忆会发送给当前配置的 AI 服务处理。',
        soulTitle: 'AI 个性', soulDesc: 'AI 用来保持自身风格与行为偏好的设定。', soulPlaceholder: '描述 AI 的个性与行为偏好',
        profileTitle: '用户画像', profileDesc: '帮助 AI 了解你的偏好、背景和习惯。', profilePlaceholder: '记录有助于 AI 理解你的信息',
        longTermTitle: '长期记忆', longTermDesc: 'AI 从对话中整理并用于后续交流的信息。', itemCount: '{count} 条',
        edit: '编辑', delete: '删除', save: '保存', cancel: '取消', emptyContent: '暂无内容', emptyList: '还没有长期记忆。',
        addItem: '添加记忆', itemPlaceholder: '输入一条希望 AI 记住的信息', invalidJson: 'JSON 格式无效，请检查后重试。', saved: '记忆已保存。',
        deleteConfirm: '确定删除这条长期记忆吗？', clearTitle: '清空记忆', clearDesc: '重置 AI 个性、用户画像和所有长期记忆，不会删除聊天记录或模型配置。',
        clearButton: '清空全部记忆', clearConfirm: '确定清空全部记忆吗？此操作不可撤销。', cleared: '记忆已清空。'
      },
      modelManagement: '模型管理',
      add: '新增',
      builtinModelHintPrefix: '当前使用内置模型，建议',
      addModelLink: '添加模型',
      builtinModelHintSuffix: '',
      emptyConfig: '暂无配置',
      modelCount: '{count} 个模型',
      activeModel: '已启用',
      edit: '编辑',
      delete: '删除',
      moreActions: '更多操作',
      tokenStore: 'Token 商店',
      officialSite: '官网',
      buy: '购买',
      inputPrice: '输入价格',
      outputPrice: '补全价格',
      countPrice: '单次价格',
      perUse: '次',
      purchaseAmount: '支付金额',
      confirmPay: '确认支付',
      processing: '处理中...',
      loadingStore: '正在加载商店...',
      amountPlaceholder: '金额（5元起）',
      tokenStoreTip: '作者仅对于官方模型做转发，方便您快速配置。推荐进入官方购买。',
      purchasedModel: '已购买模型',
      balanceLoading: '余额加载中...',
      balanceUnavailable: '余额暂不可用',
      balanceAmount: '余额：{amount} 元',
      balanceQuota: '余额：{quota} quota',
      loadStoreFailed: '加载商店失败',
      createOrderFailed: '创建订单失败',
      queryOrderFailed: '查询订单失败',
      minAmountTip: '购买金额最低 5 元',
      purchaseSuccessTip: '购买成功，已自动添加并切换到该模型。请确认拓展保存 key。',
      purchaseSuccessTitle: '购买成功',
      purchaseSuccessDefaultModel: '已将「{name}」设置为默认模型，现在可以直接开始聊天。',
      goChatNow: '点此去聊天',
      stayInStore: '继续看看',
      purchaseFailed: '购买失败',
      purchaseTimeout: '支付确认超时，请稍后重新打开设置查看',
      orderManagement: '订单管理',
      refreshOrders: '刷新订单',
      noOrders: '暂无订单，购买后会自动保存订单号',
      refresh: '刷新',
      copyKey: '复制 Key',
      viewConfig: '查看',
      configDetail: '配置详情',
      copyAll: '一键复制全部',
      useNow: '一键使用',
      added: '已添加',
      orderPending: '待支付',
      orderPaid: '已支付',
      orderIssued: '已发放',
      orderFailed: '失败',
      copySuccess: 'Key 已复制',
      orderNotIssued: '订单尚未发放 key，请稍后刷新',
      modelAlreadyAdded: '该订单模型已添加',
      useSuccess: '已添加并切换到该模型',
      addModel: '添加模型',
      editModel: '编辑模型',
      back: '返回',
      provider: '服务商',
      tutorial: '教程',
      modelType: '模型类型',
      configName: '配置名称',
      configNamePlaceholder: '如: OpenAI GPT-4',
      modelIdentifier: '模型标识',
      customModelPlaceholder: '搜索或自定义模型名称',
      addCustomModel: '添加自定义模型',
      searchModels: '搜索模型标识',
      selectAllModels: '全选',
      clearAllModels: '取消全选',
      selectedModelsCount: '已选 {selected} / {total}',
      allModels: '全部模型',
      selectedModels: '已选模型',
      removeSelectedModel: '移出已选',
      noSelectedModels: '暂未选择模型，点击上方胶囊添加',
      fetchModels: '获取',
      fetchingModels: '获取中...',
      fetchedModelsHint: '已获取 {count} 个模型，可在下方选择',
      cachedModelsHint: '已恢复 {count} 个模型，可继续选择',
      selectFetchedModel: '选择一个模型',
      modelListEmpty: '没有获取到可用模型',
      noMatchingModels: '没有匹配的模型',
      dragToSort: '拖拽排序',
      pinModel: '置顶模型',
      unpinModel: '取消置顶',
      fetchModelsNeedEndpoint: '请先填写接口地址',
      fetchModelsInvalidEndpoint: '接口地址格式不正确',
      fetchModelsNeedApiKey: '请输入对应平台提供的接口密钥',
      fetchModelsNeedRealHost: '请先把示例 host 替换成真实域名',
      fetchModelsFailed: '获取模型列表失败',
      fetchModelsFailedWithMessage: '获取模型列表失败：{message}',
      endpoint: '接口地址',
      apiKey: 'API 密钥',
      saveConfig: '保存配置',
      backupTitle: '备份',
      localSessionBackups: {
        title: '聊天记录本地备份',
        description: '自动保留最近 5 天的聊天记录快照，仅存储在此设备。',
        loading: '正在读取备份…',
        loadFailed: '读取备份失败：{message}',
        empty: '暂无可用备份',
        counts: '{sessions} 个会话 · {messages} 条消息',
        view: '查看',
        restore: '一键恢复',
        previewTitle: '{date} 备份预览',
        close: '收起',
        untitled: '未命名会话',
        sessionMessages: '{count} 条消息',
        message: '消息',
        noMessages: '此会话没有消息',
        notFound: '备份不存在或已失效',
        actionFailed: '操作失败：{message}',
        restoreSuccess: '已恢复 {count} 个会话。'
      },
      avatarAlt: '头像',
      notLoggedIn: '未登录',
      loggedInCloudSync: '已登录云端同步',
      loginToEnableCloudSync: '登录以开启云端同步',
      login: '登录',
      logout: '退出登录',
      cloudSyncEnabled: '云端同步开启',
      syncing: '同步中...',
      syncNow: '立即同步',
      backupReminderDays: '备份提醒天数',
      daysValue: '{days}天',
      localDataManagement: '本地数据管理',
      dataImport: '数据导入',
      dataExport: '数据导出',
      dangerZone: '危险区域',
      clearAllLocalData: '清除所有本地数据',
      actionIrreversible: '此操作不可撤销',
      aboutTitle: '关于 RainSee AI',
      aboutDescription: 'RainSee AI 是一个开源的、纯净的、安全且私有化的 AI 客户端。我们致力于提供最优质的 AI 交互体验，同时保障您的数据完全由您自己掌控。',
      githubRepo: 'GitHub 开源仓库',
      privacyPolicy: '隐私协议',
      termsOfService: '服务条款',
      starSupport: '如果觉得好用，请在 GitHub 上点个 Star 支持一下！',
      versionLabel: '版本',
      modelTypes: {
        text: '文字',
        t2i: '文生图',
        i2i: '图生图'
      },
      modelCategories: {
        text: '对话生成 (Text)',
        t2i: '文生图 (Image)',
        i2i: '图生图 (Vision)'
      },
      fillRequired: '请填写所有必填项（名称、接口地址、模型标识）。',
      deleteModelConfirm: '确定要删除这个模型配置吗？',
      backupReminderPrompt: '设置多少天未备份后提醒您（天）:',
      loginInBrowserFirst: '请先在浏览器中登录',
      loginExpired: '登录已失效，请重新登录。',
      cloudBackupSuccess: '云端备份成功！',
      backupFailed: '备份失败',
      cloudBackupFailed: '云端备份失败：{message}',
      cloudRestoreConfirm: '从云端恢复将会覆盖当前所有本地数据。确定要继续吗？',
      cloudRestoreSuccess: '云端恢复成功，页面将刷新以应用更改。',
      cloudBackupNotFound: '云端没有找到备份数据。',
      cloudRestoreFailed: '云端恢复失败：{message}',
      exportFailed: '导出失败：{message}',
      importConfirm: '导入备份将会覆盖当前所有数据。确定要继续吗？',
      importSuccess: '导入成功，页面将刷新以应用更改。',
      importFailed: '导入失败：备份文件格式不正确。',
      clearAllConfirm: '警告：此操作将永久清除所有本地数据（聊天记录、模型配置、记忆等）。此操作不可撤销！确定要继续吗？',
      clearAllSuccess: '所有数据已清除，页面将刷新。'
    },
    loginQRCode: {
      loginSyncHint: '登录后即可使用云端同步功能，多设备实时同步数据。',
      loginRainsee: '登录雨见账号',
      loading: '加载中...',
      scanTip: '请使用雨见浏览器扫描二维码登录',
      cancelLogin: '取消登录'
    },
    tempEmailCard: {
      loadingEmail: '正在生成临时邮箱...',
      title: '您的专属临时邮箱',
      validUntil: '有效至: {time}',
      copy: '复制',
      autoFillActive: '自动填入中...',
      autoFill: '自动填入网页',
      password: '密码: {password}',
      inbox: '收件箱 ({count})',
      refreshing: '刷新中...',
      refresh: '刷新',
      waitingEmails: '等待接收邮件中...',
      detectedCode: '识别到验证码：',
      copyCode: '复制验证码',
      generationFailed: '抱歉，临时邮箱生成失败。',
      fillCodeCommand: '请在网页中找到验证码输入框，并填入验证码：{code}',
      fillFormCommand: '请在网页中找到邮箱输入框，并填入邮箱地址：{email}。如果页面有密码或重复密码输入框，请都填入：{password}。填完上述内容后，请自动点击页面上的“获取验证码”或类似按钮。'
    },
    welcomeWizard: {
      heroPrefix: '雨见',
      heroHighlight: 'AI 客户端',
      heroSubtitle: '纯净 · 安全 · 私有化',
      introText: '这是一个不直接提供 AI 服务的纯净客户端，您需要自行配置服务接口。',
      openSource: '已开源: {repo}',
      memoryTitle: '专属记忆',
      memoryDesc: '本地数据库，打造懂你的 AI',
      privacyTitle: '数据隐私',
      privacyDesc: '数据仅存储在本地，完全由您掌控',
      imageSupport: '绘画支持',
      planMode: '计划模式',
      unlimitedChat: '无限制对话',
      startConfig: '开始配置',
      configTitle: '配置文字合成接口',
      configDesc: '为了开始使用，请配置一个基础的文字对话模型接口。',
      provider: '供应商 (Provider)',
      viewTutorialTitle: '查看配置教程',
      viewTutorial: '查看教程',
      configName: '配置名称',
      configNamePlaceholder: '例如：我的 GPT-4',
      endpoint: 'API 终端 (Endpoint)',
      endpointHint: '兼容 OpenAI API 格式',
      apiKey: 'API 密钥',
      modelName: '模型名称 (Model Name)',
      previous: '上一步',
      startUsing: '开始使用',
      defaultModelName: '我的 AI 模型'
    },
    modelSwitchModal: {
      title: '切换大模型',
      conversationModel: '对话生成模型',
      settingsTitle: '设置模型',
      settingsDesc: '添加或管理模型配置'
    },
    mobileUploadView: {
      title: '上传文件到知识库',
      subtitlePrefix: '该链接 ',
      subtitleSuffix: ' 后失效，您可以将其发送到电脑端进行大文件上传。',
      checking: '正在校验密钥状态...',
      expiredTitle: '密钥已失效',
      expiredDesc: '该上传链接已超过 30 分钟或已被使用。请返回原页面重新获取。',
      uploading: '正在上传文件...',
      dropHere: '点击或拖拽文件到此处',
      supportedFormats: '支持 PDF, DOCX, TXT, Markdown 等格式',
      uploadSuccess: '上传成功！您可以在原页面查看',
      copyLink: '复制链接到电脑',
      timeFormat: '{minutes}分{seconds}秒',
      uploadFailed: '上传失败: {message}',
      uploadError: '上传出错，请稍后重试',
      copyLinkSuccess: '链接已复制，请发送到电脑端打开'
    },
    kbDetailsModal: {
      title: '引用详情',
      knowledgeSegment: '知识片段 {index}',
      relevance: '相关度: {score}%',
      expandAll: '展开全部',
      collapse: '收起',
      localDocument: '本地文档',
      viewOriginal: '查看原文'
    },
    historyModal: {
      title: '全部历史会话',
      searchPlaceholder: '搜索历史会话...',
      emptyState: '没有找到相关会话',
      sessionMeta: '{time} · 包含 {count} 条对话',
      newChat: '新建会话',
      groups: {
        today: '今天',
        yesterday: '昨天',
        lastWeek: '上周',
        earlier: '更早以前'
      }
    },
    agreementModal: {
      loading: '加载中...',
      understood: '我已了解',
      privacyTitle: '隐私协议',
      termsTitle: '服务条款',
      loadFailed: '加载{title}失败，请稍后重试。'
    },
    formulaPreviewModal: {
      title: '公式预览',
      copied: '已复制',
      copyRawFormula: '复制原公式',
      renderError: '渲染错误'
    },
    knowledgeBasePanel: {
      title: '我的知识库',
      exportZip: '导出为 ZIP',
      storedStats: '已存储 {count} 篇内容 · 占用 {size}',
      dropToUpload: '释放文件以上传到知识库',
      loginRequired: '必须登录才可以使用知识库功能',
      syncing: '正在同步知识库环境...',
      back: '返回',
      createContent: '创作知识内容',
      titlePlaceholder: '输入标题...',
      saveToKnowledgeBase: '保存到知识库',
      saving: '保存中...',
      uploadParsing: '上传并解析中...',
      uploadLocalFile: '上传本地文件',
      createNewContent: '创作新内容',
      emptyDocuments: '暂无文档，请先上传文件',
      typeUrl: '网址',
      typeNote: '笔记',
      typeFile: '文件',
      characters: '{count} 字符',
      paragraphs: '{count} 分段',
      editContent: '编辑内容',
      deleteContent: '删除内容',
      loadingMore: '正在加载更多...',
      noMoreDocuments: '没有更多文档了',
      showNextPage: '展示下一页',
      contentPlaceholder: '输入正文内容...',
      uploadFailed: '上传失败: {message}',
      uploadRequestError: '上传请求出错',
      getUploadKeyFailed: '获取上传密钥失败: {message}',
      requestUploadKeyError: '请求上传密钥出错',
      exportFailed: '导出失败: {message}',
      exportRequestError: '导出请求出错',
      draftFromSession: '已带入当前会话内容',
      draftLoaded: '已加载草稿',
      draftSaving: '保存中...',
      draftSaved: '草稿已保存',
      editSuccess: '修改成功',
      editFailed: '修改失败: {message}',
      saveSuccess: '保存成功',
      saveFailed: '保存失败: {message}',
      requestError: '操作请求出错',
      deleteConfirm: '确定要删除这条知识内容吗？',
      deleteFailed: '删除失败: {message}',
      deleteRequestError: '删除请求出错',
      statuses: {
        started: '解析中',
        success: '就绪',
        failed: '失败',
        unknown: '未知'
      },
      time: {
        justNow: '刚刚',
        todayAt: '今天 {time}',
        yesterdayAt: '昨天 {time}'
      }
    },
    legacy: {
      'Remove attachment': '移除附件',
      'Uploading...': '上传中...',
      'Select Modes': '选择功能模式',
      'Deep Thinking Mode': '深度思考模式',
      'Web Search Mode': '联网搜索模式',
      'Image Generation Mode': 'AI 绘图模式',
      'Plan Mode': 'Plan 模式',
      'Attach File': '上传文件',
      'Stop generation': '停止生成',
      'Send message': '发送消息',
      'Upload failed or returned invalid URL.': '上传失败或返回了无效链接。',
      'Document processing failed.': '文档处理失败。',
      'Failed to upload file.': '文件上传失败。',
      'Preview formula:': '预览公式：',
      'Session': '会话',
      'Today': '今天',
      'Yesterday': '昨天',
      'Last Week': '上周',
      'Earlier': '更早以前'
    }
  },
  en: {
    app: {
      rainseeTitle: 'RainSee AI',
      xinyiTitle: 'Xinyi AI',
      aihelpTitle: 'aihelp'
    },
    language: {
      label: 'Language',
      options: {
        zh: '中文',
        en: 'English'
      }
    },
    chatLayout: {
      newChat: 'New Chat',
      backupReminderButton: 'Backup reminder',
      emptyState: 'How can I help you today?',
      copyCode: 'Copy',
      copied: 'Copied',
      deleteSessionConfirm: 'Are you sure you want to delete this chat session?',
      scrapeStatusSingle: 'Fetching webpage content {url} ({seconds}s)...',
      scrapeStatusMulti: 'Fetching webpage content ({finished}/{total}) ({seconds}s)...',
      backupNever: 'You have not backed up your data yet. Click here to export a backup.',
      backupOverdue: 'It has been {days} days since your last backup. Click to back up now.',
      exportFailed: 'Export failed: {message}'
    },
    markdownRenderer: {
      copyCode: 'Copy',
      editCode: 'Edit',
      copied: 'Copied',
      copyFailed: 'Copy failed'
    },
    codeEditor: {
      title: 'Edit code',
      defaultName: 'Code snippet',
      aiDescription: 'Describe the change and AI will edit the current code step by step.',
      promptPlaceholder: 'For example: replace the loop with map and add error handling',
      safetyNote: 'Changes only update this code block in the chat. Nothing is executed.',
      footerHint: 'Saving replaces this code block in the conversation.',
      save: 'Save to chat',
      publishing: 'Saving...',
      applied: 'Code updated',
      applyFailed: 'Could not locate the original code block. Nothing was written.',
      sourceChanged: 'This message has changed, so the code block could not be updated.'
    },
    browserAgent: {
      unnamedSession: 'Untitled session',
      conversationUser: 'User',
      conversationAssistant: 'Assistant',
      kbRequiresLogin: 'You need to sign in to use the knowledge base.',
      noConversationForKb: 'There is no conversation content to organize into the knowledge base yet.',
      pageUrlUnavailable: 'Unable to get the current webpage URL.',
      selectionTextUnavailable: 'Unable to get the selected text.',
      kbAdded: 'Added to the knowledge base successfully.',
      kbAddFailed: 'Add failed: {message}',
      requestRetry: 'Request failed. Please try again later.',
      unknownPage: 'Unknown webpage',
      kbLookupStatus: 'Searching the knowledge base ({seconds}s)...',
      kbLookupStopped: 'Knowledge base lookup stopped. Answering directly...',
      pdfExportNotReady: 'Full PDF export is not implemented yet. You can use the browser print function to save it.',
      copied: 'Copied',
      loadingFailed: 'Sorry, I could not read the current webpage content. That is okay though, you can still use me like a normal AI assistant and ask anything.',
      contextStopped: 'Webpage reading has been stopped. I am now acting as a normal AI assistant, so feel free to ask anything.',
      searchSeenPrefix: 'I can see that you are searching for',
      searchSeenSuffix: ', and I can answer it directly for you.',
      askAnything: 'Or you can ask me anything else',
      pageSeenPrefix: 'I can see that you are viewing',
      pageSeenFallback: 'this webpage',
      pageSeenMiddle: ', and I have already loaded the',
      pageSeenSuffix: 'skill for you.',
      preparedQuestions: 'I prepared a few questions you might want to ask, and of course you can also ask me anything else',
      decision: {
        pageAction: 'Executing webpage action: **{command}**...',
        generateCharacter: 'Generating a character card for you: **{name}**...',
        addToKnowledgeBase: 'Adding the webpage to the knowledge base...'
      },
      quickActions: {
        tempEmail: 'Temporary Email',
        tempEmailResponse: 'To protect your privacy and reduce spam, I have generated a dedicated temporary email address for you. It is only valid for 10 minutes.\n\n⚠️ **Note**: Please do not use it for any illegal or abusive activity.',
        addToKnowledgeBase: 'Add to Knowledge Base',
        askSelection: 'Please answer based on the text I selected, explain the key points first, then add any useful context.',
        addToKnowledgeBaseResponse: 'Sure, I am adding the current webpage to your personal knowledge base...'
      },
      system: {
        defaultRolePrompt: 'You are a browser AI assistant.',
        searchSummary: 'The user is searching for: {summary}',
        pageContext: 'Current webpage title: {title}\nWebpage URL: {url}\nWebpage summary:\n{summary}',
        searchEngineHeader: '\n\n[Information from the search engine]:\n',
        referencesHeader: 'References:\n',
        kbHeader: '\n\n[Reference information from the knowledge base]:\n',
        kbSegment: '--- Knowledge segment {index} ---\n{content}\n',
        kbInstruction: '\nPlease answer the user by combining the reference information above from the knowledge base. If the reference information does not cover the topic, answer with your own knowledge.\n'
      }
    },
    browserAgentChat: {
      thinkingSearch: 'Online search process and results',
      thinking: 'Thinking process',
      viewFile: 'Open {name}',
      answerDirectly: 'Answer directly',
      kbJudgingStatus: 'Filtering {count} knowledge base segments...',
      kbUseDirectly: 'Use directly',
      kbSkip: 'Skip sources',
      drawing: 'AI is drawing...',
      copyTraceId: 'Copy conversation ID {id}',
      aiGenerated: 'Generated by AI',
      quotaLimitTitle: 'Daily free limit reached',
      quotaLimitDesc: 'The built-in free model allows {limit} requests per day. Today\'s quota is used up and resets within 24 hours.',
      quotaLimitUsage: 'Used today {limit} / {limit}',
      quotaLimitUpsell: 'Don\'t want to wait? Buy tokens and pay as you go from ¥1. We switch you over automatically, with no daily limit.',
      quotaLimitBuy: 'Buy tokens to continue',
      quotaLimitByok: 'Or add your own API key in Settings',
      quotaSwitchedTitle: 'Switched to {name}',
      quotaSwitchedDesc: 'Replies now use your model and no longer count toward the daily free limit.',
      quotaAskAgain: 'Ask again',
      commandRequest: 'AI requests to run a command',
      reject: 'Reject',
      allowExecution: 'Allow execution',
      kbSources: 'Knowledge base sources',
      quotedSegments: 'Quoted segments {count}',
      unknownSource: 'Unknown source',
      searchSuggestion: 'Search for {keyword} on {engine}',
      copy: 'Copy',
      edit: 'Edit',
      stopSpeaking: 'Stop reading',
      speak: 'Read aloud',
      knowledgeBase: 'Knowledge Base',
      export: 'Export',
      exportPdf: 'Export PDF',
      exportWord: 'Export Word',
      exportMarkdown: 'Export Markdown',
      aiAssistant: 'AI Assistant',
      selectedTextPrefix: 'I noticed that you selected',
      selectedTextSuffix: '. Do you want to:',
      fillInput: 'Insert into input',
      traceCopiedAlert: 'The conversation ID has been copied. During testing, if you hit a problem, please send the ID to the author to help with troubleshooting. Thank you.',
      report: 'Report',
      reportDialogTitle: 'Report this reply',
      reportDialogTraceId: 'Conversation ID: {id}',
      reportTypeLabel: 'Issue type',
      reportReasonLabel: 'Reason',
      reportReasonPlaceholder: 'Describe the issue so it can be reviewed.',
      reportCancel: 'Cancel',
      reportSubmit: 'Submit report',
      reportSubmitting: 'Submitting...',
      reportReasonRequired: 'Please enter a reason',
      reportSuccessAlert: 'Report submitted. Thank you for the feedback.',
      reportFailed: 'Failed to submit the report. Please try again later.',
      reportTypeFactuallyIncorrect: 'Factually incorrect',
      reportTypeIllegal: 'Illegal or non-compliant',
      reportTypeFraud: 'Fraud or misleading',
      reportTypePorn: 'Sexual or vulgar',
      reportTypeViolence: 'Violence or hate',
      reportTypePrivacy: 'Privacy infringement',
      reportTypeOther: 'Other issue',
      userscriptReady: 'Script generated',
      userscriptVersion: 'Version {version}',
      installUserscript: 'Install script',
      editUserscript: 'Edit code',
      engines: {
        baidu: 'Baidu',
        mita: 'Mita'
      }
    },
    userscriptEditor: {
      title: 'Edit webpage script',
      defaultName: 'Current userscript',
      close: 'Close editor',
      sourceTitle: 'Source editor',
      unsaved: 'Unsaved changes',
      saved: 'No changes',
      aiTitle: 'Ask AI to edit',
      aiDescription: 'Describe the change and AI will work from the current source.',
      promptLabel: 'Change request',
      promptPlaceholder: 'For example: add a toggle in the lower-right corner to pause the script',
      modify: 'Modify source',
      stop: 'Stop',
      modifying: 'AI is modifying the source...',
      modifySuccess: 'The change is in the editor. Review it before saving.',
      modifyStopped: 'Modification stopped. The current source was kept.',
      modifyFailed: 'AI modification failed. Please try again.',
      requestStep: 'Change request',
      waitingStep: 'Waiting for AI instruction',
      waitingStepMessage: 'Choosing the next step from {count} tool results...',
      viewStep: 'View command and result',
      toolStep: 'Run tool',
      searchStep: 'Search source',
      readStep: 'Read source',
      replaceStep: 'Modify source',
      replaceFailed: 'Replacement not applied',
      finishStep: 'Finish edit',
      editComplete: 'Edit complete',
      editStopped: 'Edit stopped',
      noChanges: 'AI did not make any source changes.',
      tooManySteps: 'The AI edit exceeded 16 tool steps and was stopped.',
      emptySource: 'Source cannot be empty.',
      sourceTooLarge: 'Source cannot exceed 512KB.',
      syntaxError: 'Source syntax error',
      safetyNote: 'This script runs on the current webpage. Keep only code you trust.',
      footerHint: 'Saving creates a new script link without adding a chat message.',
      cancel: 'Cancel',
      save: 'Save and return',
      publishing: 'Publishing...',
      publishFailed: 'Script publishing failed. Please try again.',
      discardConfirm: 'There are unsaved changes. Discard them and return to chat?'
    },
    chatInput: {
      instructions: ['Help me understand this', 'What is this?'],
      uploadInvalidUrl: 'Upload failed or returned an invalid URL.',
      documentProcessingFailed: 'Document processing failed.',
      fileUploadFailed: 'Failed to upload the file.',
      voiceUnsupported: 'This browser does not support voice input.',
      microphoneDenied: 'Voice input failed because microphone permission was denied. Please allow microphone access in your browser settings.',
      voiceError: 'Voice input error: {message}',
      unknownError: 'Unknown error'
    },
    characterManager: {
      title: 'Companion Center',
      myRoles: 'My Companions',
      onlineStore: 'Online Store',
      createRole: '+ Create Your Companion',
      import: '📥 Import',
      myDownloads: 'My Downloads / Custom',
      uncategorized: 'Uncategorized',
      shareToStore: 'Share to store',
      exportJson: 'Export JSON',
      edit: 'Edit',
      delete: 'Delete',
      systemDefault: 'System Default',
      hide: 'Hide',
      hideBlockedRoles: 'Hide blocked companions',
      showHiddenRoles: 'Show {count} hidden companions',
      restoreVisibility: 'Restore visibility',
      loadingStore: 'Loading online store...',
      downloadRole: 'Get companion',
      emptyStore: 'No online companions yet',
      editRole: 'Edit Companion',
      createNewRole: 'Create Your Companion',
      avatarLabel: 'Avatar (Emoji)',
      nameLabel: 'Name',
      namePlaceholder: 'Companion name',
      shortDescriptionLabel: 'Short Description',
      descriptionPlaceholder: 'Describe this companion in one sentence',
      aliasesLabel: 'Aliases',
      aliasesPlaceholder: 'e.g. translator, English translation (comma-separated)',
      systemPromptLabel: 'System Prompt (Core Setup)',
      systemPromptPlaceholder: 'Describe the companion’s abilities, workflow, tone, and more...',
      tagsLabel: 'Tags',
      tagsPlaceholder: 'For example: assistant, coding, funny (comma-separated)',
      cancel: 'Cancel',
      save: 'Save',
      deleteConfirm: 'Are you sure you want to delete this companion?',
      importSuccess: 'Import successful!',
      importFailed: 'Import failed: invalid file format',
      shareConfirm: 'Share this companion to the online store? Anyone will be able to view and download it.',
      shareSuccess: 'Shared successfully!',
      shareFailed: 'Share failed: {message}',
      unknownError: 'Unknown error',
      duplicateDownloaded: 'Replaced the existing companion "{name}" and added it to "My Companions"',
      downloaded: 'Downloaded and added to "My Companions"'
    },
    settingsModal: {
      title: 'Settings',
      tabs: {
        general: 'General',
        model: 'Models',
        appearance: 'Appearance',
        memory: 'Memory',
        backup: 'Backup',
        about: 'About'
      },
      generalTitle: 'General Settings',
      theme: 'Theme',
      themeLight: 'Light',
      themeDark: 'Dark',
      appearanceTitle: 'Appearance Settings',
      fontSizeLabel: 'Chat font size',
      fontPreview: 'This is a preview of the adjusted text size',
      memory: {
        title: 'Memory Management', subtitle: 'Review and manage the memories AI uses to understand you and maintain its personality.', localBadge: 'Stored locally',
        privacyTitle: 'Your memories are stored locally',
        privacyDesc: 'Memories are stored in this browser’s local database and are not saved as cloud-synced data. When AI automatically organizes memories, relevant conversation content and existing memories are sent to your configured AI service for processing.',
        soulTitle: 'AI Personality', soulDesc: 'Settings that guide the AI’s style and behavior.', soulPlaceholder: 'Describe the AI’s personality and behavior preferences',
        profileTitle: 'User Profile', profileDesc: 'Preferences, background, and habits that help the AI understand you.', profilePlaceholder: 'Add information that helps the AI understand you',
        longTermTitle: 'Long-term Memories', longTermDesc: 'Information organized from conversations for future interactions.', itemCount: '{count} items',
        edit: 'Edit', delete: 'Delete', save: 'Save', cancel: 'Cancel', emptyContent: 'No content yet', emptyList: 'No long-term memories yet.',
        addItem: 'Add memory', itemPlaceholder: 'Enter something you want the AI to remember', invalidJson: 'Invalid JSON. Check the format and try again.', saved: 'Memory saved.',
        deleteConfirm: 'Delete this long-term memory?', clearTitle: 'Clear memories', clearDesc: 'Reset AI personality, user profile, and all long-term memories. Chat history and model settings will not be deleted.',
        clearButton: 'Clear all memories', clearConfirm: 'Clear all memories? This cannot be undone.', cleared: 'Memories cleared.'
      },
      modelManagement: 'Model Management',
      add: 'Add',
      builtinModelHintPrefix: 'The built-in model is currently in use. Consider ',
      addModelLink: 'adding a model',
      builtinModelHintSuffix: '.',
      emptyConfig: 'No configuration yet',
      modelCount: '{count} models',
      activeModel: 'Active',
      edit: 'Edit',
      delete: 'Delete',
      moreActions: 'More actions',
      tokenStore: 'Token Store',
      officialSite: 'Official site',
      buy: 'Buy',
      inputPrice: 'Input price',
      outputPrice: 'Output price',
      countPrice: 'Per-use price',
      perUse: 'use',
      purchaseAmount: 'Payment amount',
      confirmPay: 'Confirm payment',
      processing: 'Processing...',
      loadingStore: 'Loading store...',
      amountPlaceholder: 'Amount (min ¥5)',
      tokenStoreTip: 'The author only forwards official models to help you configure quickly. Buying directly from the official provider is recommended.',
      purchasedModel: 'Purchased model',
      balanceLoading: 'Loading balance...',
      balanceUnavailable: 'Balance unavailable',
      balanceAmount: 'Balance: ¥{amount}',
      balanceQuota: 'Balance: {quota} quota',
      loadStoreFailed: 'Failed to load store',
      createOrderFailed: 'Failed to create order',
      queryOrderFailed: 'Failed to query order',
      minAmountTip: 'Minimum purchase amount is ¥5',
      purchaseSuccessTip: 'Purchase successful. The model was added and selected automatically. Please confirm the extension saved the key.',
      purchaseSuccessTitle: 'Purchase successful',
      purchaseSuccessDefaultModel: '“{name}” is now your default model. You can start chatting right away.',
      goChatNow: 'Go chat now',
      stayInStore: 'Keep browsing',
      purchaseFailed: 'Purchase failed',
      purchaseTimeout: 'Payment confirmation timed out. Reopen settings later to check.',
      orderManagement: 'Orders',
      refreshOrders: 'Refresh orders',
      noOrders: 'No orders yet. Order numbers are saved after purchase.',
      refresh: 'Refresh',
      copyKey: 'Copy key',
      viewConfig: 'View',
      configDetail: 'Configuration',
      copyAll: 'Copy all',
      useNow: 'Use now',
      added: 'Added',
      orderPending: 'Pending',
      orderPaid: 'Paid',
      orderIssued: 'Issued',
      orderFailed: 'Failed',
      copySuccess: 'Key copied',
      orderNotIssued: 'The key has not been issued yet. Refresh later.',
      modelAlreadyAdded: 'This order model has already been added.',
      useSuccess: 'Added and switched to this model.',
      addModel: 'Add Model',
      editModel: 'Edit Model',
      back: 'Back',
      provider: 'Provider',
      tutorial: 'Guide',
      modelType: 'Model Type',
      configName: 'Configuration Name',
      configNamePlaceholder: 'e.g. OpenAI GPT-4',
      modelIdentifier: 'Model Identifier',
      customModelPlaceholder: 'Search or enter a custom model name',
      addCustomModel: 'Add custom model',
      searchModels: 'Search model identifiers',
      selectAllModels: 'Select all',
      clearAllModels: 'Clear all',
      selectedModelsCount: '{selected} / {total} selected',
      allModels: 'All models',
      selectedModels: 'Selected models',
      removeSelectedModel: 'Remove from selected',
      noSelectedModels: 'No models selected. Click a capsule above to add one.',
      fetchModels: 'Fetch',
      fetchingModels: 'Fetching...',
      fetchedModelsHint: '{count} models loaded. Select one below.',
      cachedModelsHint: '{count} models restored. You can continue selecting.',
      selectFetchedModel: 'Select a model',
      modelListEmpty: 'No available models were returned.',
      noMatchingModels: 'No matching models.',
      dragToSort: 'Drag to reorder',
      pinModel: 'Pin model',
      unpinModel: 'Unpin model',
      fetchModelsNeedEndpoint: 'Please fill in the endpoint first.',
      fetchModelsInvalidEndpoint: 'The endpoint format is invalid.',
      fetchModelsNeedApiKey: 'Please enter the API key provided by the platform.',
      fetchModelsNeedRealHost: 'Replace the example host with a real domain first.',
      fetchModelsFailed: 'Failed to fetch model list.',
      fetchModelsFailedWithMessage: 'Failed to fetch model list: {message}',
      endpoint: 'Endpoint',
      apiKey: 'API Key',
      saveConfig: 'Save Configuration',
      backupTitle: 'Backup',
      localSessionBackups: {
        title: 'Local chat history backups',
        description: 'Automatic chat snapshots from the last 5 days, stored on this device only.',
        loading: 'Loading backups…',
        loadFailed: 'Failed to load backups: {message}',
        empty: 'No backups available',
        counts: '{sessions} sessions · {messages} messages',
        view: 'View',
        restore: 'Restore',
        previewTitle: '{date} backup preview',
        close: 'Close',
        untitled: 'Untitled session',
        sessionMessages: '{count} messages',
        message: 'Message',
        noMessages: 'This session has no messages',
        notFound: 'Backup not found or expired',
        actionFailed: 'Operation failed: {message}',
        restoreSuccess: 'Restored {count} sessions.'
      },
      avatarAlt: 'Avatar',
      notLoggedIn: 'Not signed in',
      loggedInCloudSync: 'Cloud sync connected',
      loginToEnableCloudSync: 'Sign in to enable cloud sync',
      login: 'Sign in',
      logout: 'Sign out',
      cloudSyncEnabled: 'Cloud sync enabled',
      syncing: 'Syncing...',
      syncNow: 'Sync now',
      backupReminderDays: 'Backup reminder days',
      daysValue: '{days} days',
      localDataManagement: 'Local Data Management',
      dataImport: 'Import Data',
      dataExport: 'Export Data',
      dangerZone: 'Danger Zone',
      clearAllLocalData: 'Clear all local data',
      actionIrreversible: 'This action cannot be undone',
      aboutTitle: 'About RainSee AI',
      aboutDescription: 'RainSee AI is an open-source, clean, secure, and private AI client. We aim to provide a great AI interaction experience while keeping your data fully under your control.',
      githubRepo: 'GitHub Repository',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      starSupport: 'If you find it useful, please give it a Star on GitHub to support the project.',
      versionLabel: 'Version',
      modelTypes: {
        text: 'Text',
        t2i: 'Text to Image',
        i2i: 'Image to Image'
      },
      modelCategories: {
        text: 'Conversation (Text)',
        t2i: 'Text to Image (Image)',
        i2i: 'Image to Image (Vision)'
      },
      fillRequired: 'Please fill in all required fields (Name, Endpoint, Model Identifier).',
      deleteModelConfirm: 'Are you sure you want to delete this model configuration?',
      backupReminderPrompt: 'Remind me after how many days without a backup? (days):',
      loginInBrowserFirst: 'Please sign in in the browser first.',
      loginExpired: 'Your session has expired. Please sign in again.',
      cloudBackupSuccess: 'Cloud backup completed successfully!',
      backupFailed: 'Backup failed',
      cloudBackupFailed: 'Cloud backup failed: {message}',
      cloudRestoreConfirm: 'Restoring from the cloud will overwrite all current local data. Do you want to continue?',
      cloudRestoreSuccess: 'Cloud restore completed successfully. The page will refresh to apply the changes.',
      cloudBackupNotFound: 'No backup data was found in the cloud.',
      cloudRestoreFailed: 'Cloud restore failed: {message}',
      exportFailed: 'Export failed: {message}',
      importConfirm: 'Importing a backup will overwrite all current data. Do you want to continue?',
      importSuccess: 'Import completed successfully. The page will refresh to apply the changes.',
      importFailed: 'Import failed: invalid backup file format.',
      clearAllConfirm: 'Warning: this will permanently clear all local data, including chat history, model configurations, and memory. This action cannot be undone. Do you want to continue?',
      clearAllSuccess: 'All data has been cleared. The page will refresh.'
    },
    loginQRCode: {
      loginSyncHint: 'Sign in to use cloud sync and keep data updated across devices.',
      loginRainsee: 'Sign in with RainSee account',
      loading: 'Loading...',
      scanTip: 'Please scan the QR code with RainSee Browser to sign in',
      cancelLogin: 'Cancel sign in'
    },
    tempEmailCard: {
      loadingEmail: 'Generating a temporary email...',
      title: 'Your temporary inbox',
      validUntil: 'Valid until: {time}',
      copy: 'Copy',
      autoFillActive: 'Auto-filling...',
      autoFill: 'Auto-fill webpage',
      password: 'Password: {password}',
      inbox: 'Inbox ({count})',
      refreshing: 'Refreshing...',
      refresh: 'Refresh',
      waitingEmails: 'Waiting for emails...',
      detectedCode: 'Verification code detected:',
      copyCode: 'Copy code',
      generationFailed: 'Sorry, failed to generate a temporary email.',
      fillCodeCommand: 'Please find the verification code input on the webpage and fill in this code: {code}',
      fillFormCommand: 'Please find the email input on the webpage and fill in this address: {email}. If the page has password or confirm password fields, fill both with: {password}. After that, automatically click the "Get verification code" button or a similar button on the page.'
    },
    welcomeWizard: {
      heroPrefix: 'RainSee',
      heroHighlight: 'AI Client',
      heroSubtitle: 'Clean · Secure · Private',
      introText: 'This is a clean client that does not directly provide AI services. You need to configure your own service endpoint.',
      openSource: 'Open source: {repo}',
      memoryTitle: 'Personal Memory',
      memoryDesc: 'A local database that makes your AI understand you better',
      privacyTitle: 'Data Privacy',
      privacyDesc: 'Your data stays local and fully under your control',
      imageSupport: 'Image support',
      planMode: 'Plan mode',
      unlimitedChat: 'Unlimited chat',
      startConfig: 'Start setup',
      configTitle: 'Configure text generation API',
      configDesc: 'To get started, configure a basic text chat model endpoint.',
      provider: 'Provider',
      viewTutorialTitle: 'View setup guide',
      viewTutorial: 'View guide',
      configName: 'Configuration Name',
      configNamePlaceholder: 'For example: My GPT-4',
      endpoint: 'API Endpoint',
      endpointHint: 'Compatible with the OpenAI API format',
      apiKey: 'API Key',
      modelName: 'Model Name',
      previous: 'Back',
      startUsing: 'Start using',
      defaultModelName: 'My AI Model'
    },
    modelSwitchModal: {
      title: 'Switch Model',
      conversationModel: 'Conversation model',
      settingsTitle: 'Model settings',
      settingsDesc: 'Add or manage model configurations'
    },
    mobileUploadView: {
      title: 'Upload Files to Knowledge Base',
      subtitlePrefix: 'This link expires in ',
      subtitleSuffix: '. You can send it to your desktop for large file uploads.',
      checking: 'Checking key status...',
      expiredTitle: 'Key expired',
      expiredDesc: 'This upload link has expired after 30 minutes or has already been used. Please return to the original page and get a new one.',
      uploading: 'Uploading file...',
      dropHere: 'Click or drag a file here',
      supportedFormats: 'Supports PDF, DOCX, TXT, Markdown, and more',
      uploadSuccess: 'Upload successful. You can view it on the original page.',
      copyLink: 'Copy link to desktop',
      timeFormat: '{minutes}m {seconds}s',
      uploadFailed: 'Upload failed: {message}',
      uploadError: 'Upload failed. Please try again later.',
      copyLinkSuccess: 'Link copied. Please open it on your desktop.'
    },
    kbDetailsModal: {
      title: 'Reference Details',
      knowledgeSegment: 'Knowledge Segment {index}',
      relevance: 'Relevance: {score}%',
      expandAll: 'Expand all',
      collapse: 'Collapse',
      localDocument: 'Local document',
      viewOriginal: 'View original'
    },
    historyModal: {
      title: 'All chat history',
      searchPlaceholder: 'Search chat history...',
      emptyState: 'No matching chats found',
      sessionMeta: '{time} · {count} messages',
      newChat: 'New chat',
      groups: {
        today: 'Today',
        yesterday: 'Yesterday',
        lastWeek: 'Last Week',
        earlier: 'Earlier'
      }
    },
    agreementModal: {
      loading: 'Loading...',
      understood: 'Got it',
      privacyTitle: 'Privacy Policy',
      termsTitle: 'Terms of Service',
      loadFailed: 'Failed to load {title}. Please try again later.'
    },
    formulaPreviewModal: {
      title: 'Formula Preview',
      copied: 'Copied',
      copyRawFormula: 'Copy raw formula',
      renderError: 'Render error'
    },
    knowledgeBasePanel: {
      title: 'My Knowledge Base',
      exportZip: 'Export as ZIP',
      storedStats: 'Stored {count} items · {size} used',
      dropToUpload: 'Drop files to upload to the knowledge base',
      loginRequired: 'You need to sign in to use the knowledge base.',
      syncing: 'Syncing knowledge base environment...',
      back: 'Back',
      createContent: 'Create Knowledge Content',
      titlePlaceholder: 'Enter a title...',
      saveToKnowledgeBase: 'Save to knowledge base',
      saving: 'Saving...',
      uploadParsing: 'Uploading and parsing...',
      uploadLocalFile: 'Upload local file',
      createNewContent: 'Create new content',
      emptyDocuments: 'No documents yet. Upload a file first.',
      typeUrl: 'URL',
      typeNote: 'Note',
      typeFile: 'File',
      characters: '{count} chars',
      paragraphs: '{count} paragraphs',
      editContent: 'Edit content',
      deleteContent: 'Delete content',
      loadingMore: 'Loading more...',
      noMoreDocuments: 'No more documents',
      showNextPage: 'Show next page',
      contentPlaceholder: 'Enter content...',
      uploadFailed: 'Upload failed: {message}',
      uploadRequestError: 'Upload request failed',
      getUploadKeyFailed: 'Failed to get upload key: {message}',
      requestUploadKeyError: 'Failed to request upload key',
      exportFailed: 'Export failed: {message}',
      exportRequestError: 'Export request failed',
      draftFromSession: 'Current chat content imported',
      draftLoaded: 'Draft loaded',
      draftSaving: 'Saving draft...',
      draftSaved: 'Draft saved',
      editSuccess: 'Updated successfully',
      editFailed: 'Update failed: {message}',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Save failed: {message}',
      requestError: 'Request failed',
      deleteConfirm: 'Are you sure you want to delete this knowledge item?',
      deleteFailed: 'Delete failed: {message}',
      deleteRequestError: 'Delete request failed',
      statuses: {
        started: 'Parsing',
        success: 'Ready',
        failed: 'Failed',
        unknown: 'Unknown'
      },
      time: {
        justNow: 'Just now',
        todayAt: 'Today {time}',
        yesterdayAt: 'Yesterday {time}'
      }
    },
    legacy: {
      '登录提醒': 'Login reminder',
      '由于应用商店要求，您必须登录才可以使用服务，或者您可以选择自定义 AI 服务接口。': 'Because of app store requirements, you must sign in to use the service, or you can choose to configure your own AI service endpoint.',
      '自定义配置': 'Custom setup',
      '立即登录': 'Sign in now',
      '雨见智慧体': 'RainSee Agent',
      '打造通用智能库，智能识别当前网页。<br>帮您突破信息茧房，建立跨页面的终身知识记忆库。<br>由全球领先的智能大模型驱动。': 'Build a general intelligence library that understands the current webpage.<br>Break through information bubbles and build a lifelong knowledge memory across pages.<br>Powered by leading large AI models.',
      '每日免费对话额度': 'Daily free chat quota',
      '畅享深度网页解析与互动': 'Enjoy deep webpage analysis and interaction',
      '支持配置 AI 接口': 'Supports custom AI endpoints',
      '您可以自定义专属的大模型': 'Configure your own preferred large model',
      '我已阅读并同意': 'I have read and agree',
      '《隐私协议》': 'Privacy Policy',
      '和': 'and',
      '《服务条款》': 'Terms of Service',
      '确定并进入': 'Confirm and continue',
      '一键添加到知识库': 'Add to knowledge base',
      '将当前对话整理到知识库': 'Organize this conversation into the knowledge base',
      '知识': 'Knowledge',
      '正在努力阅读网页中...': 'Reading the webpage...',
      '终止': 'Stop',
      '你可能感兴趣': 'You may be interested in',
      '选中的内容': 'Selected content',
      '隐藏选中文本建议': 'Hide selected text suggestions',
      '填充到输入框': 'Insert into input',
      '推荐操作': 'Suggested actions',
      'AI也可能会犯错。请核查重要信息': 'AI can make mistakes. Please verify important information.',
      '选择功能模式': 'Choose a mode',
      '深度思考': 'Deep Thinking',
      '使用深度推理模型解决复杂问题': 'Use deep reasoning models for complex problems',
      '联网搜索': 'Web Search',
      '搜索互联网获取实时信息': 'Search the internet for real-time information',
      'AI绘图': 'AI Drawing',
      '根据文本描述生成图片': 'Generate images from text prompts',
      'Plan模式': 'Plan Mode',
      '生成并执行复杂计划': 'Generate and execute complex plans',
      '检索知识库': 'Knowledge Base',
      '知识库关联': 'Knowledge Base',
      '优先使用知识库检索结果回答问题': 'Prefer knowledge base results when answering',
      '请先登录': 'Please sign in first',
      '拖拽文件到这里上传': 'Drag files here to upload',
      '有新内容，点此回到底部': 'New content available. Tap to jump to the bottom',
      '小贴士：如果新的问题与之前不相关，建议': 'Tip: if your new question is unrelated to the previous one, consider',
      '新建会话': 'starting a new chat',
      '，这样 AI 的理解会更精准哦。': ' so the AI can stay more accurate.',
      '云端数据与本地不同': 'Cloud data differs from local data',
      '同步云端': 'Download',
      '覆盖云端': 'Overwrite',
      '点击打开文件': 'Open file',
      '有什么可以帮你的吗...': 'How can I help you?',
      '试试这样问': 'Try asking',
      '选择角色': 'Choose companion',
      '选择伙伴': 'Choose companion',
      '角色': 'Companion',
      '伙伴': 'Companion',
      '点击更换角色': 'Click to change companion',
      '点击更换伙伴': 'Click to change companion',
      '取消角色': 'Clear companion',
      '移除伙伴': 'Remove companion',
      '功能模式': 'Modes',
      '宽高比': 'Aspect ratio',
      '分辨率': 'Resolution',
      '停止语音输入': 'Stop voice input',
      '语音输入': 'Voice input',
      '切换大模型': 'Switch model',
      '我的知识库': 'My knowledge base',
      '管理知识库': 'Manage the knowledge base',
      '最近会话': 'Recent chats',
      '查看全部': 'View all',
      '当前会话': 'Current chat',
      '系统': 'System',
      '夜间模式': 'Dark mode',
      '设置': 'Settings',
      '未登录': 'Not signed in',
      '点击登录': 'Tap to sign in',
      '全部历史会话': 'All chat history',
      '搜索历史会话...': 'Search chat history...',
      '没有找到相关会话': 'No matching chats found',
      '登录后即可使用云端同步功能，多设备实时同步数据。': 'Sign in to use cloud sync and keep data updated across devices.',
      '登录雨见账号': 'Sign in with RainSee account',
      '加载中...': 'Loading...',
      '请使用雨见浏览器扫描二维码登录': 'Please scan the QR code with RainSee Browser to sign in',
      '取消登录': 'Cancel sign in',
      '引用详情': 'Reference details',
      '展开全部': 'Expand all',
      '收起': 'Collapse',
      '本地文档': 'Local document',
      '查看原文': 'View original',
      '保存图片': 'Save image',
      '公式预览': 'Formula preview',
      '已复制': 'Copied',
      '复制原公式': 'Copy raw formula',
      '渲染错误': 'Render error',
      '切换大模型': 'Switch model',
      '对话生成模型': 'Conversation model',
      '添加或管理模型配置': 'Add or manage model configurations',
      '设置模型': 'Model settings',
      '加载中...': 'Loading...',
      '未命名会话': 'Untitled session',
      '网页': 'webpage',
      '智能网页助手': 'Smart Web Assistant',
      '沉浸阅读助手': 'Immersive Reading Assistant',
      '帮你找回纯净阅读体验': 'Bring back a clean reading experience',
      'Zine 模式': 'Zine Mode',
      '广告清洗 & 重新排版': 'Ad cleanup & relayout',
      '网页整容术': 'Webpage Makeover',
      '一键提取核心正文<br>套用极致阅读模板': 'Extract the core article with one tap<br>Apply a premium reading layout',
      '帮我重新排版这个网页': 'Reformat this webpage for me',
      '请提取当前网页的核心正文内容，抛弃原 HTML 结构，重新排版，去除所有广告和冗余信息。': 'Please extract the core article from the current webpage, discard the original HTML structure, reformat it, and remove all ads and redundant information.',
      '生成精美金句卡片': 'Create a quote card',
      '请提取文章中的核心金句，并为其设计一个精美的排版卡片。': 'Please extract the key quotes from the article and design a beautiful quote card for them.',
      '大白话翻译官': 'Plain-Language Translator',
      '让复杂知识变简单': 'Make complex knowledge easy to understand',
      '降维解释': 'Simple Explanation',
      '打破专业壁垒': 'Break through expert barriers',
      '知识降维': 'Knowledge Simplifier',
      '太专业看不懂？<br>我用大白话讲给你听': 'Too technical to follow?<br>I will explain it in plain language',
      '用小学三年级水平重新解释': 'Explain it like to a third grader',
      '请将当前网页的内容，用小学三年级学生能听懂的大白话重新改写一遍。': 'Please rewrite the current webpage content in plain language that a third-grade student can understand.',
      '生成大字号适老版摘要': 'Create a senior-friendly summary',
      '请为老年人总结这篇文章，要求通俗易懂，突出重点，并使用大字号排版。': 'Please summarize this article for older readers using simple language, highlight the key points, and format it with large text.',
      '数据抓取专家': 'Data Extraction Expert',
      '一键提取网页数据': 'Extract webpage data with one tap',
      '零代码爬虫': 'No-Code Scraper',
      '杂乱信息整理': 'Organize messy information',
      '结构化提取': 'Structured Extraction',
      '财报、代码、参数<br>秒变整齐表格': 'Financial reports, code, and specs<br>turned into neat tables instantly',
      '将页面表格转为 CSV/Excel': 'Convert tables to CSV/Excel',
      '请识别当前网页中的所有数据表格或列表，并将其转换为 CSV 格式输出。': 'Please identify all data tables or lists on the current webpage and convert them to CSV output.',
      '抓取核心参数指标': 'Extract key parameters',
      '请提取网页中的核心规格、参数或代码片段，并使用 Markdown 格式化整理。': 'Please extract the key specs, parameters, or code snippets from the webpage and format them in Markdown.',
      '追书伴侣': 'Novel Companion',
      '沉浸式角色扮演体验': 'Immersive role-playing experience',
      '小说模式': 'Novel Mode',
      '连载网文辅助': 'Serialized web novel helper',
      '剧情透视': 'Plot Insight',
      '角色关系梳理、前情提要<br>甚至与主角对话': 'Map character relationships, recap previous events<br>and even talk to the main character',
      '总结本章剧情和出场人物': 'Summarize this chapter and its characters',
      '请总结当前这一章节的核心剧情，并列出本章出场的所有关键人物及其状态。': 'Please summarize the core plot of this chapter and list all key characters who appear in it along with their current status.',
      '基于文章内容进行角色扮演': 'Role-play based on the article',
      '请扮演本文的主角，以第一人称视角和我聊聊你现在的处境。': 'Please act as the main character of this article and talk to me in the first person about your current situation.',
      '反方辩手': 'Devil’s Advocate',
      '帮你打破信息茧房': 'Help you break out of your information bubble',
      '批判性思考': 'Critical Thinking',
      '逻辑漏洞侦测器': 'Logic flaw detector',
      '杠精模式': 'Devil’s Advocate Mode',
      '情绪化长文鉴定<br>寻找数据缺失与谬误': 'Inspect emotional long-form writing<br>and find missing data or fallacies',
      '指出文章的逻辑漏洞': 'Point out the article’s logic flaws',
      '请扮演一个专业的反方辩手（杠精），找出当前网页内容中的逻辑漏洞或数据缺失，并给出强有力的对立观点。': 'Please act as a professional devil’s advocate, find the logic flaws or missing data in the current webpage content, and provide strong counterarguments.',
      '这句话的隐藏目的是什么？': 'What is the hidden agenda behind this sentence?',
      '请分析这篇长文背后的潜在意图、情绪引导手法，是否在制造焦虑？': 'Please analyze the hidden intent and emotional steering tactics behind this long article. Is it trying to create anxiety?',
      '配料表审查员': 'Ingredient List Inspector',
      '看透商品真实成分': 'See the real ingredients behind a product',
      '成分透视镜': 'Ingredient Lens',
      '虚假宣传终结者': 'False marketing buster',
      '配料解析': 'Ingredient Analysis',
      '致敏源预警、化学名词翻译<br>买得更放心': 'Allergen alerts and chemical term translation<br>so you can buy with more confidence',
      '分析成分表，找出致敏源/风险项': 'Analyze ingredients for allergens and risks',
      '请提取网页商品图片或文本中的配料表/成分表，翻译生僻的化学名词，并用红绿灯形式标注出潜在的致敏源或健康风险项。': 'Please extract the ingredient list from the product image or text on the webpage, translate unfamiliar chemical terms, and mark potential allergens or health risks with a traffic-light style indicator.',
      '核实商品宣传是否夸大': 'Check whether the marketing is exaggerated',
      '根据其成分列表，判断该商品宣称的功效是否有科学依据，是否存在虚假宣传？': 'Based on its ingredient list, determine whether the product’s claimed benefits are scientifically supported and whether the marketing may be misleading.',
      '真相核查机': 'Truth Checker',
      '对假新闻说不': 'Say no to fake news',
      '事实核查': 'Fact Check',
      '可疑内容拦截': 'Suspicious content filter',
      '辟谣助手': 'Debunking Assistant',
      '交叉比对内部知识库<br>揭穿谣言与谬误': 'Cross-check against internal knowledge<br>to expose rumors and fallacies',
      '核查本文提及的核心事实': 'Verify the key facts in this article',
      '请提取这篇文章中的核心事实断言和数据，利用你的内部知识库进行交叉核查，指出其中可能的谬误或争议点。': 'Please extract the core factual claims and data from this article, cross-check them with your internal knowledge, and point out possible fallacies or disputed points.',
      '提供事件的另一面报道': 'Show another side of the story',
      '针对这个新闻事件，请为我提供与之立场不同或补充性的事实背景。': 'For this news event, please provide factual background that offers a different angle or complementary perspective.',
      '吃瓜向导': 'Relationship Guide',
      '一秒理清复杂关系': 'Untangle complex relationships instantly',
      '知识图谱': 'Knowledge Graph',
      '实体关系网络': 'Entity relationship network',
      '人物图谱': 'People Map',
      '新闻吃瓜、公司纠纷<br>不再晕头转向': 'Celebrity news and company disputes<br>without getting lost',
      '梳理文章中的人物/公司关系': 'Map the people and company relationships',
      '请提取网页中的所有人名、公司名等实体，梳理出他们之间的关联，并以结构化格式（如 Markdown 列表）输出关系网络。': 'Please extract all entities such as people and companies from the webpage, identify their relationships, and output the network in a structured format such as a Markdown list.',
      '总结事件的时间线': 'Summarize the timeline',
      '请根据文章内容，按时间先后顺序整理出该纠纷/事件的完整时间线。': 'Please organize the full timeline of the dispute or event in chronological order based on the article.',
      '网购防坑助手': 'Online Shopping Guard',
      '拒绝电商杀熟': 'Avoid e-commerce price discrimination',
      '全网比价': 'Price Comparison',
      '差评提炼与历史价格': 'Highlight bad reviews and price history',
      '比价透视眼': 'Price Insight',
      '看透商品真实底价<br>帮你提炼隐蔽差评': 'See the true bottom price<br>and surface hidden negative reviews',
      '帮我提炼这款商品的真实差评': 'Summarize the real negative reviews',
      '请分析该商品的评论区内容，忽略刷单好评，专门为我总结出该商品的典型差评、质量缺陷和常见槽点。': 'Please analyze the product review section, ignore fake positive reviews, and summarize the typical negative reviews, quality issues, and common complaints for me.',
      '寻找全网平替款': 'Find better-value alternatives',
      '请根据当前商品的特征、材质和参数，为我推荐几款性价比更高的“平替”商品。': 'Based on the current product’s features, materials, and specifications, recommend several more cost-effective alternatives.',
      'Hi，我是你的网页AI助手': 'Hi, I am your webpage AI assistant',
      '你的AI工作伙伴': 'Your AI work partner',
      '助手来了': 'Your assistant is here',
      '长文总结、网页翻译<br>问我就知道': 'Long article summaries and webpage translation<br>just ask me',
      '总结这篇长文的核心观点是什么？': 'What are the core points of this long article?',
      '请帮我用一段话总结当前网页的核心内容。': 'Please summarize the core content of the current webpage in one paragraph.',
      '帮我把当前网页转成 PDF 输出？': 'Can you help me export this webpage as a PDF?',
      '我想把当前网页保存为 PDF，请指导我如何操作或帮我提取排版好的正文。': 'I want to save the current webpage as a PDF. Please guide me or help me extract the well-formatted main content.',
      '提取网页中的所有图片': 'Extract all images from the webpage',
      '请帮我汇总并提取当前网页中的所有关键图片资源。': 'Please gather and extract all key image assets from the current webpage.',
      '全能专家': 'General Expert',
      '知识渊博，能够回答各种问题': 'Knowledgeable and able to answer all kinds of questions',
      '律师': 'Lawyer',
      '提供专业的法律咨询': 'Provides professional legal advice',
      '老师': 'Teacher',
      '耐心解答，循循善诱': 'Patient explanations with step-by-step guidance',
      '生物专家': 'Biology Expert',
      '解答生物学相关问题': 'Answers biology-related questions',
      '程序员': 'Programmer',
      '编写代码，解决技术难题': 'Writes code and solves technical problems',
      '心理咨询师': 'Therapist',
      '倾听烦恼，提供心理疏导': 'Listens to concerns and offers emotional support',
      '翻译官': 'Translator',
      '专业翻译，支持多种语言': 'Professional translation across multiple languages',
      '健身教练': 'Fitness Coach',
      '提供运动指导和健身计划': 'Provides workout guidance and fitness plans',
      '大厨': 'Chef',
      '提供食谱和烹饪技巧': 'Provides recipes and cooking tips',
      '旅行规划师': 'Travel Planner',
      '规划行程，推荐景点': 'Plans itineraries and recommends destinations',
      '理财顾问': 'Financial Advisor',
      '提供投资建议和财务规划': 'Provides investment advice and financial planning',
      '育儿专家': 'Parenting Expert',
      '解答育儿难题，提供建议': 'Answers parenting questions and offers advice',
      '历史学家': 'Historian',
      '讲述历史故事，解析事件': 'Explains historical stories and events',
      '影评人': 'Film Critic',
      '推荐电影，深入解析剧情': 'Recommends films and analyzes plots deeply',
      '营养师': 'Nutritionist',
      '提供健康饮食建议': 'Provides healthy diet advice',
      '职业规划师': 'Career Coach',
      '职业发展建议和简历优化': 'Offers career advice and resume improvement',
      '作家/诗人': 'Writer / Poet',
      '创作文学作品，润色文字': 'Creates literary works and polishes writing',
      '营销专家': 'Marketing Expert',
      '制定营销策略和文案创意': 'Creates marketing strategies and copy ideas',
      '游戏策划': 'Game Designer',
      '设计游戏机制和背景故事': 'Designs gameplay systems and story worlds',
      '天文学家': 'Astronomer',
      '探索宇宙奥秘，解答问题': 'Explores the universe and answers questions',
      '占星师': 'Astrologer',
      '解读星座运势和星盘': 'Interprets horoscopes and birth charts',
      '摄影师': 'Photographer',
      '提供构图建议和后期技巧': 'Provides composition advice and editing tips',
      '语言伙伴': 'Language Partner',
      '练习对话，纠正语法错误': 'Practices conversation and corrects grammar mistakes',
      '辩论教练': 'Debate Coach',
      '提升逻辑思维和辩论技巧': 'Improves reasoning and debate skills',
      '产品经理': 'Product Manager',
      '分析需求，打磨产品逻辑': 'Analyzes requirements and refines product logic',
      '室内设计师': 'Interior Designer',
      '提供装修建议和空间布局': 'Provides interior ideas and space planning',
      '智能搜索助手': 'Smart Search Assistant',
      'Hi，我是你的搜索AI助手': 'Hi, I am your search AI assistant',
      '搜索助手': 'Search Assistant',
      '帮你直接找到答案': 'Help you get the answer directly',
      '直达答案': 'Direct Answer',
      '直接给出搜索结果<br>无需点开多个网页': 'Give the answer directly<br>without opening multiple webpages',
      '直接给我答案': 'Give me the answer directly',
      '请直接给我这个搜索词的答案。': 'Please give me the answer to this search query directly.',
      '错误排查助手': 'Error Troubleshooting Assistant',
      '检测到页面加载异常': 'Page loading issue detected',
      '错误排查': 'Troubleshooting',
      '帮你分析网页报错原因': 'Help you analyze webpage errors',
      '深度分析页面报错<br>提供修复建议': 'Analyze page errors in depth<br>and provide fixes',
      '帮我排查这个网页错误': 'Help me troubleshoot this webpage error',
      '请分析当前网页的报错信息（如 404, 500 等），解释原因并提供可能的解决建议。': 'Please analyze the error information on the current webpage, such as 404 or 500 errors, explain the cause, and provide possible fixes.',
      '如何修复此类加载问题？': 'How can I fix this kind of loading issue?',
      '针对当前页面的加载异常，有哪些通用的排查和修复方案？': 'For the current page loading issue, what general troubleshooting and repair approaches are available?',
      '提取报错的具体堆栈信息': 'Extract the exact stack trace',
      '请从当前网页内容中提取出具体的错误堆栈或报错代码段。': 'Please extract the specific error stack trace or code snippet from the current webpage content.',
      '智能助手': 'Smart Assistant',
      'Loading...': 'Loading...',
      'Remove attachment': 'Remove attachment',
      'Uploading...': 'Uploading...',
      'Select Modes': 'Choose a mode',
      'Deep Thinking Mode': 'Deep Thinking Mode',
      'Web Search Mode': 'Web Search Mode',
      'Image Generation Mode': 'Image Generation Mode',
      'Plan Mode': 'Plan Mode',
      'Attach File': 'Attach file',
      'Stop generation': 'Stop generation',
      'Send message': 'Send message'
    }
  }
};
